/* unplugin-vue-components disabled */import { render } from "./MoblieFooter.vue?vue&type=template&id=fb3c78ac"
import script from "./MoblieFooter.vue?vue&type=script&lang=js"
export * from "./MoblieFooter.vue?vue&type=script&lang=js"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__